import { handleAPIError } from "@services/Base";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { SCENARIO_API_URL } from "../../../config";
import { ScenarioSimulation, ScenarioSimulationResponse } from "../types";

export const useScenarioSimulation = (data: ScenarioSimulation) => {
  return useQuery({
    queryKey: ["center", "model", data.model_id, JSON.stringify(data)],
    enabled: data.prediction_dates.length > 0,
    queryFn: ({ signal }) =>
      axios
        .post(
          `${SCENARIO_API_URL}/waves-scenario-manager-api/v1/scenarios/simulate`,
          data,
          {
            signal
          }
        )
        .then((response) => {
          return response.data as ScenarioSimulationResponse;
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
